module.exports = __webpack_public_path__ + "img/no_photo_2.f9bfe901.png";